/* Phoenix Framers — Shop Frames and Design Your Frame.
   Data comes from <script id="PfFrameData"> (snippets/pf-frame-data.liquid).

   Price = moulding + mount + glazing + backing/fitting + fixed charge (never below the minimum):
     moulding  = perimeter of the mount (or artwork) + 8 × face width for mitres, in metres × €/m for the width
     mount     = outer mount area in m² × mount rate        (single mount only)
     glazing   = outer mount area in m² × glazing rate
     backing   = outer mount area in m² × backing rate
   Totals round up to the next whole euro, then to the next price band of the checkout product. */
(function () {
  'use strict';
  if (window.PfFrames) return;

  var dataEl = document.getElementById('PfFrameData');
  if (!dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var UNIT = { cm: 1, mm: 0.1, in: 2.54 };
  var UNIT_LABEL = { cm: 'cm', mm: 'mm', in: 'in' };
  var GLAZING = { standard: 'Standard glass', acrylic: 'AR70 anti-reflective glass', museum: 'Museum glass' };

  function num(v) { var n = parseFloat(String(v || '').replace(',', '.')); return isFinite(n) && n > 0 ? n : null; }
  function isNum(v) { return typeof v === 'number' && isFinite(v); }
  function round1(n) { return Math.round(n * 10) / 10; }
  function fmt(n) {
    try { return new Intl.NumberFormat('en-IE', { style: 'currency', currency: D.currency || 'EUR', maximumFractionDigits: 0 }).format(n); }
    catch (e) { return '€' + Math.round(n); }
  }
  function frameById(id) { for (var i = 0; i < D.frames.length; i++) if (D.frames[i].id === id) return D.frames[i]; return D.frames[0]; }
  function widthById(id) { for (var i = 0; i < D.widths.length; i++) if (D.widths[i].id === id) return D.widths[i]; return D.widths[0]; }

  /* spec: { wCm, hCm, frame, width, mount: 'none'|'single', mwidth, glazing } */
  function price(spec) {
    var out = { ok: false, total: null, externalW: null, externalH: null, reason: '' };
    var w = widthById(spec.width);
    if (!isNum(spec.wCm) || !isNum(spec.hCm)) { out.reason = 'size'; return out; }
    var longS = Math.max(spec.wCm, spec.hCm), shortS = Math.min(spec.wCm, spec.hCm);
    var border = spec.mount === 'single' ? (D.mount[spec.mwidth] || 0) : 0;
    var ow = spec.wCm + 2 * border, oh = spec.hCm + 2 * border;
    var face = (w && w.face ? w.face : 15) / 10;
    out.externalW = round1(ow + 2 * face);
    out.externalH = round1(oh + 2 * face);
    if (shortS < D.minSide) { out.reason = 'small'; return out; }
    if (longS > D.maxLong || shortS > D.maxShort) { out.reason = 'review'; return out; }
    var glazeRate = D.glazing[spec.glazing];
    if (!w || !isNum(w.rate) || !isNum(D.backing) || !isNum(glazeRate) || (spec.mount === 'single' && !isNum(D.mount.rate))) {
      out.reason = spec.glazing === 'museum' && !isNum(glazeRate) && w && isNum(w.rate) ? 'ask-glazing' : 'no-rates';
      return out;
    }
    var metres = (2 * (ow + oh) + 8 * face) / 100;
    var area = (ow * oh) / 10000;
    var total = metres * w.rate + area * glazeRate + area * D.backing + (spec.mount === 'single' ? area * D.mount.rate : 0) + (D.fixed || 0);
    total = Math.max(Math.ceil(total), D.minPrice || 0);
    out.ok = true; out.total = total;
    return out;
  }

  /* Checkout product: one variant per price. Loaded once. */
  var bandsPromise = null;
  function loadBands() {
    if (bandsPromise) return bandsPromise;
    bandsPromise = fetch('/products/' + encodeURIComponent(D.bandProduct) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('no band product'); return r.json(); })
      .then(function (p) {
        return p.variants.filter(function (v) { return v.available; })
          .map(function (v) { return { id: v.id, price: v.price / 100 }; })
          .sort(function (a, b) { return a.price - b.price; });
      })
      .catch(function () { return []; });
    return bandsPromise;
  }
  function bandFor(bands, total) {
    for (var i = 0; i < bands.length; i++) if (bands[i].price >= total - 0.001) return bands[i];
    return null;
  }

  function specText(spec, res, unit) {
    var f = frameById(spec.frame), w = widthById(spec.width);
    var u = unit || 'cm', k = UNIT[u];
    var size = round1(spec.wCm / k) + ' × ' + round1(spec.hCm / k) + ' ' + UNIT_LABEL[u];
    var lines = [
      'Frame: ' + f.name + (w ? ', ' + w.label : '') + (f.code && w && w.code ? ' (' + w.code + f.code + ')' : ''),
      'Artwork size: ' + size,
      'Mount: ' + (spec.mount === 'single' ? 'Single mount, ' + spec.mcolor.toLowerCase() + ', ' + spec.mwidth + ' width' : 'No mount'),
      'Glazing: ' + GLAZING[spec.glazing]
    ];
    if (res && isNum(res.externalW)) lines.push('External frame size: ' + res.externalW + ' × ' + res.externalH + ' cm');
    if (res && res.ok) lines.push('Online price shown: ' + fmt(res.total));
    return lines;
  }

  window.PfFrames = { data: D, price: price, fmt: fmt, loadBands: loadBands, bandFor: bandFor, specText: specText };

  /* ---------------------------------------------------------------- Shop Frames */
  function initCatalogue(root) {
    var grid = root.querySelector('[data-pf-grid-frames]');
    if (!grid) return;
    var shortcutsEl = root.querySelector('[data-pf-shortcuts]');
    var finishBox = root.querySelector('[data-pf-filter-finish]');
    var widthBox = root.querySelector('[data-pf-filter-width]');
    var countEl = root.querySelector('[data-pf-count]');
    var sortEl = root.querySelector('[data-pf-sort]');
    var designUrl = D.designUrl;
    var state = { finishes: [], widths: [] };

    function corner(f, cls) {
      if (f.image) return '<img class="' + cls + '" src="' + f.image + '" alt="" loading="lazy">';
      return '<span class="' + cls + ' pf-corner" style="--c:' + f.color + '"><span></span></span>';
    }
    function examplePrice(f) {
      var best = null;
      D.widths.forEach(function (w) {
        var r = price({ wCm: D.example[0], hCm: D.example[1], frame: f.id, width: w.id, mount: 'none', mwidth: 'standard', glazing: 'standard' });
        if (r.ok && (best === null || r.total < best)) best = r.total;
      });
      return best;
    }

    // Shortcuts
    if (shortcutsEl) {
      var html = '<button type="button" class="pf-cat-sc" aria-pressed="true" data-sc="all"><span class="pf-cat-sc__all" aria-hidden="true">';
      D.frames.slice(0, 4).forEach(function (f) { html += '<i style="background:' + f.color + '"></i>'; });
      html += '</span><span>All Frames</span></button>';
      D.frames.forEach(function (f) {
        html += '<button type="button" class="pf-cat-sc" aria-pressed="false" data-sc="' + f.id + '">' + corner(f, 'pf-cat-sc__img') + '<span>' + f.finish + '</span></button>';
      });
      shortcutsEl.innerHTML = html;
      shortcutsEl.addEventListener('click', function (e) {
        var b = e.target.closest('[data-sc]'); if (!b) return;
        var id = b.getAttribute('data-sc');
        state.finishes = id === 'all' ? [] : [id];
        syncChecks(); render();
      });
    }
    // Filters
    if (finishBox) finishBox.innerHTML = D.frames.map(function (f) {
      return '<label class="pf-check"><input type="checkbox" value="' + f.id + '"><i style="background:' + f.color + '"></i>' + f.finish + '</label>';
    }).join('');
    if (widthBox) widthBox.innerHTML = D.widths.map(function (w) {
      return '<label class="pf-check"><input type="checkbox" value="' + w.id + '">' + w.label + '</label>';
    }).join('');
    function syncChecks() {
      if (finishBox) finishBox.querySelectorAll('input').forEach(function (i) { i.checked = state.finishes.indexOf(i.value) !== -1; });
      if (widthBox) widthBox.querySelectorAll('input').forEach(function (i) { i.checked = state.widths.indexOf(i.value) !== -1; });
    }
    function readChecks() {
      state.finishes = finishBox ? Array.prototype.filter.call(finishBox.querySelectorAll('input'), function (i) { return i.checked; }).map(function (i) { return i.value; }) : [];
      state.widths = widthBox ? Array.prototype.filter.call(widthBox.querySelectorAll('input'), function (i) { return i.checked; }).map(function (i) { return i.value; }) : [];
    }
    root.addEventListener('change', function (e) { if (e.target.closest('[data-pf-filter-finish],[data-pf-filter-width]')) { readChecks(); render(); } });
    var reset = root.querySelector('[data-pf-reset]');
    if (reset) reset.addEventListener('click', function () { state.finishes = []; state.widths = []; syncChecks(); render(); });
    if (sortEl) sortEl.addEventListener('change', render);

    function render() {
      var widthIds = state.widths.length ? state.widths : D.widths.map(function (w) { return w.id; });
      var list = D.frames.filter(function (f) { return !state.finishes.length || state.finishes.indexOf(f.id) !== -1; })
        .map(function (f, i) { return { f: f, i: i, p: examplePrice(f) }; });
      var sort = sortEl ? sortEl.value : 'featured';
      if (sort === 'name') list.sort(function (a, b) { return a.f.name.localeCompare(b.f.name); });
      if (sort === 'price-asc') list.sort(function (a, b) { return (a.p || 1e9) - (b.p || 1e9); });
      if (sort === 'price-desc') list.sort(function (a, b) { return (b.p || 0) - (a.p || 0); });
      var labels = D.widths.filter(function (w) { return widthIds.indexOf(w.id) !== -1; }).map(function (w) { return w.label.split(' ')[0]; });
      grid.innerHTML = list.map(function (o) {
        var f = o.f;
        var href = designUrl + '?frame=' + encodeURIComponent(f.id) + (state.widths.length === 1 ? '&width=' + state.widths[0] : '');
        var priceLine = o.p !== null ? 'e.g. ' + D.example[0] + ' × ' + D.example[1] + ' cm from ' + fmt(o.p) : 'Made to measure · from €—';
        return '<article class="pf-cat-card"><a class="pf-cat-card__img" href="' + href + '" aria-label="' + f.name + '">' + corner(f, 'pf-cat-card__corner') + '</a>' +
          '<div><h3 class="pf-h4"><a href="' + href + '">' + f.name + '</a></h3>' +
          '<p class="pf-card__desc" style="margin:6px 0 0">Flat wood moulding · ' + labels.join(', ') + ' mm face</p>' +
          '<div class="pf-cat-card__sw" aria-label="' + f.finish + '"><span style="background:' + f.color + '"></span></div>' +
          '<p class="pf-price">' + priceLine + '</p></div></article>';
      }).join('');
      if (countEl) countEl.textContent = 'Showing ' + list.length + (list.length === 1 ? ' frame' : ' frames');
      if (shortcutsEl) shortcutsEl.querySelectorAll('[data-sc]').forEach(function (b) {
        var id = b.getAttribute('data-sc');
        b.setAttribute('aria-pressed', (id === 'all' && !state.finishes.length) || (state.finishes.length === 1 && state.finishes[0] === id) ? 'true' : 'false');
      });
    }
    render();
  }

  /* ---------------------------------------------------------------- Design Your Frame */
  function initDesigner(root) {
    if (!D.frames.length || !D.widths.length) return;
    var q = new URLSearchParams(location.search);
    var $ = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
    var wIn = $('[data-pf-w]'), hIn = $('[data-pf-h]');
    var msg = $('[data-pf-size-msg]');
    var framesBox = $('[data-pf-frames]'), widthsBox = $('[data-pf-widths]');
    var addBtn = $('[data-pf-add]'), quoteBtn = $('[data-pf-quote]'), note = $('[data-pf-note]');
    var nextBtn = $('[data-pf-next]');
    var frameEl = $('[data-pf-frame]'), mountEl = $('[data-pf-mount]'), artEl = $('[data-pf-art]');

    var st = {
      unit: UNIT[q.get('u')] ? q.get('u') : 'cm',
      frame: frameById(q.get('frame') || '').id,
      width: widthById(q.get('width') || 'w1').id,
      mount: 'single', mcolor: 'White', mcolorHex: '#FFFFFF', mwidth: 'standard', glazing: 'standard'
    };
    wIn.value = q.get('w') || '40';
    hIn.value = q.get('h') || '50';
    root.querySelectorAll('input[name="pf-units"]').forEach(function (r) { r.checked = r.value === st.unit; });

    framesBox.innerHTML = D.frames.map(function (f) {
      var img = f.image ? '<img src="' + f.image + '" alt="" loading="lazy">' : '<span class="pf-corner" style="--c:' + f.color + '"><span></span></span>';
      return '<label class="pf-dz-fr"><input type="radio" name="pf-frame" value="' + f.id + '"' + (f.id === st.frame ? ' checked' : '') + '>' +
        '<span class="pf-dz-fr__in"><span class="pf-dz-fr__img" aria-hidden="true">' + img + '</span>' +
        '<span class="pf-dz-fr__txt"><b>' + f.name + '</b><small><i style="background:' + f.color + '"></i>' + f.finish + ' · flat profile</small></span>' +
        '<span class="pf-dz-fr__sel">Selected</span></span></label>';
    }).join('');
    widthsBox.innerHTML = D.widths.map(function (w) {
      return '<label><input type="radio" name="pf-width" value="' + w.id + '"' + (w.id === st.width ? ' checked' : '') + '><span>' + w.label + '</span></label>';
    }).join('');

    function spec() {
      var k = UNIT[st.unit];
      var w = num(wIn.value), h = num(hIn.value);
      return { wCm: w ? w * k : null, hCm: h ? h * k : null, frame: st.frame, width: st.width, mount: st.mount, mcolor: st.mcolor, mwidth: st.mwidth, glazing: st.glazing };
    }

    var bands = null;
    loadBands().then(function (b) { bands = b; update(); });

    function quoteHref(sp, res) {
      return D.quoteUrl + '?spec=' + encodeURIComponent(specText(sp, res, st.unit).join('\n'));
    }

    function update() {
      var sp = spec(), res = price(sp), f = frameById(st.frame), w = widthById(st.width);
      var k = UNIT[st.unit];
      // Preview
      var face = Math.max(6, Math.round((w.face || 15) * 0.9));
      frameEl.style.background = f.color;
      frameEl.style.padding = face + 'px';
      mountEl.style.background = st.mount === 'single' ? st.mcolorHex : 'transparent';
      mountEl.style.padding = st.mount === 'single' ? ({ narrow: 18, standard: 30, wide: 44 }[st.mwidth]) + 'px' : '0';
      var ratio = sp.wCm && sp.hCm ? sp.wCm / sp.hCm : 0.8;
      var maxW = 230, maxH = 260, aw = maxW, ah = maxW / ratio;
      if (ah > maxH) { ah = maxH; aw = maxH * ratio; }
      artEl.style.width = Math.round(aw) + 'px'; artEl.style.height = Math.round(ah) + 'px';
      var lbl = $('[data-pf-preview-label]');
      if (lbl) lbl.setAttribute('aria-label', 'Preview: ' + f.name + ', ' + (st.mount === 'single' ? st.mcolor.toLowerCase() + ' mount' : 'no mount'));
      // Mount options visibility
      var mo = $('[data-pf-mount-opts]'); if (mo) mo.hidden = st.mount !== 'single';
      var mcn = $('[data-pf-mcolor-name]'); if (mcn) mcn.textContent = st.mcolor;
      root.querySelectorAll('[data-unit-label]').forEach(function (el) { el.textContent = UNIT_LABEL[st.unit]; });
      // Size messages
      var bad = res.reason === 'review' || res.reason === 'small';
      [wIn, hIn].forEach(function (i) { i.setAttribute('aria-invalid', bad ? 'true' : 'false'); });
      if (bad) {
        var sizeTxt = round1(sp.wCm / k) + ' × ' + round1(sp.hCm / k) + ' ' + UNIT_LABEL[st.unit];
        msg.innerHTML = res.reason === 'review'
          ? '<p><strong>This size needs a workshop review.</strong></p><p>We can’t price ' + sizeTxt + ' online. Send it to our team and we’ll come back to you with a quote. Your frame, mount and glazing choices are kept.</p><a class="pf-btn pf-btn--primary pf-btn--sm" href="' + quoteHref(sp, res) + '">Request a Quote</a>'
          : '<p><strong>That’s smaller than we can make online.</strong></p><p>The smallest side we price online is ' + D.minSide + ' cm. Get in touch and we’ll help.</p>';
        msg.hidden = false;
      } else { msg.hidden = true; }
      // Summary
      var setSum = function (key, val) { root.querySelectorAll('[data-sum="' + key + '"]').forEach(function (el) { el.textContent = val; }); };
      setSum('frame', f.name + ', ' + w.label);
      setSum('size', sp.wCm && sp.hCm ? round1(sp.wCm / k) + ' × ' + round1(sp.hCm / k) + ' ' + UNIT_LABEL[st.unit] + (res.reason === 'review' ? ' — needs review' : '') : '—');
      setSum('mount', st.mount === 'single' ? 'Single mount, ' + st.mcolor.toLowerCase() + ', ' + st.mwidth + ' width' : 'No mount');
      setSum('glazing', GLAZING[st.glazing]);
      setSum('external', isNum(res.externalW) && !bad ? res.externalW + ' × ' + res.externalH + ' cm' : '— × — cm');
      var band = res.ok && bands ? bandFor(bands, res.total) : null;
      var shown = res.ok ? (band ? band.price : res.total) : null;
      root.querySelectorAll('[data-pf-total]').forEach(function (el) { el.textContent = shown !== null ? fmt(shown) : '€—'; });
      // Actions
      var canBuy = res.ok && D.shopOpen && !!band;
      addBtn.hidden = !canBuy && !bad ? true : false;
      addBtn.disabled = !canBuy;
      addBtn.setAttribute('aria-disabled', canBuy ? 'false' : 'true');
      quoteBtn.hidden = canBuy || bad;
      quoteBtn.href = quoteHref(sp, res);
      var ql = $('[data-pf-quote-link]'); if (ql) ql.href = quoteHref(sp, res);
      var n = '';
      if (bad) n = 'Available once your size has been reviewed.';
      else if (res.reason === 'size') n = 'Enter your artwork width and height.';
      else if (res.reason === 'ask-glazing') n = 'Museum glass is priced in the workshop. Request a quote and we’ll come back to you.';
      else if (!res.ok) n = 'Online prices are coming soon. Send us this frame and we’ll quote it.';
      else if (!D.shopOpen) n = 'Online ordering opens soon. Send us this frame and we’ll confirm the price.';
      else if (!band) n = 'This one is best priced by the workshop. Send it to us for a quote.';
      note.textContent = n;
      note.hidden = !n;
      if (typeof setNext === 'function' && root.getAttribute('data-step') === '3') setNext(3);
    }

    // Events
    root.addEventListener('input', function (e) { if (e.target === wIn || e.target === hIn) update(); });
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.name === 'pf-units') {
        var sp = spec(), newK = UNIT[t.value];
        st.unit = t.value;
        if (sp.wCm) wIn.value = round1(sp.wCm / newK);
        if (sp.hCm) hIn.value = round1(sp.hCm / newK);
      }
      if (t.name === 'pf-frame') st.frame = t.value;
      if (t.name === 'pf-width') st.width = t.value;
      if (t.name === 'pf-mount') st.mount = t.value;
      if (t.name === 'pf-mcolor') { st.mcolor = t.value; st.mcolorHex = t.getAttribute('data-color'); }
      if (t.name === 'pf-mwidth') st.mwidth = t.value;
      if (t.name === 'pf-glazing') st.glazing = t.value;
      update();
    });
    var up = $('[data-pf-upload]');
    if (up) up.addEventListener('change', function () {
      var file = up.files && up.files[0]; if (!file) return;
      var r = new FileReader();
      r.onload = function () { artEl.style.backgroundImage = 'url(' + r.result + ')'; artEl.classList.add('has-image'); };
      r.readAsDataURL(file);
    });

    addBtn.addEventListener('click', function () {
      var sp = spec(), res = price(sp);
      var band = res.ok && bands ? bandFor(bands, res.total) : null;
      if (!band || !D.shopOpen) return;
      var f = frameById(st.frame), w = widthById(st.width), k = UNIT[st.unit];
      var props = {
        'Frame': f.name + ', ' + w.label,
        'Moulding code': (w.code && f.code) ? w.code + f.code : '',
        'Artwork size': round1(sp.wCm / k) + ' × ' + round1(sp.hCm / k) + ' ' + UNIT_LABEL[st.unit],
        'Mount': st.mount === 'single' ? 'Single, ' + st.mcolor + ', ' + st.mwidth : 'None',
        'Glazing': GLAZING[st.glazing],
        'External size': res.externalW + ' × ' + res.externalH + ' cm',
        '_Calculated price': String(res.total)
      };
      if (!props['Moulding code']) delete props['Moulding code'];
      addBtn.disabled = true; addBtn.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: band.id, quantity: 1, properties: props }] }) })
        .then(function (r) { if (!r.ok) throw new Error(); location.href = '/cart'; })
        .catch(function () { addBtn.disabled = false; addBtn.textContent = 'Add to Basket'; note.textContent = 'Sorry, that didn’t work. Please try again or request a quote.'; note.hidden = false; });
    });

    // Mobile steps
    function setNext(n) {
      n = n || +root.getAttribute('data-step');
      var arrow = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
      if (n === 1) nextBtn.innerHTML = 'Next: Details ' + arrow;
      else if (n === 2) nextBtn.innerHTML = 'Next: Review ' + arrow;
      else nextBtn.textContent = !addBtn.hidden && !addBtn.disabled ? 'Add to Basket' : 'Request a quote';
    }
    function goto(n) {
      root.setAttribute('data-step', String(n));
      root.querySelectorAll('[data-progress]').forEach(function (li) {
        var p = +li.getAttribute('data-progress');
        li.classList.toggle('is-done', p < n); li.classList.toggle('is-current', p === n);
        if (p === n) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current');
      });
      setNext(n);
      if (window.matchMedia('(max-width: 989px)').matches) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    root.addEventListener('click', function (e) {
      var g = e.target.closest('[data-goto]'); if (g) { e.preventDefault(); goto(+g.getAttribute('data-goto')); }
    });
    nextBtn.addEventListener('click', function () {
      var n = +root.getAttribute('data-step');
      if (n < 3) goto(n + 1); else if (!addBtn.hidden && !addBtn.disabled) addBtn.click(); else location.href = quoteBtn.href;
    });

    goto(1);
    update();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-pf-catalogue]').forEach(initCatalogue);
    (scope || document).querySelectorAll('[data-pf-designer]').forEach(initDesigner);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
})();
